import { render, staticRenderFns } from "./ClientMonetariesTable.vue?vue&type=template&id=424e2700&scoped=true&"
import script from "./ClientMonetariesTable.vue?vue&type=script&lang=js&"
export * from "./ClientMonetariesTable.vue?vue&type=script&lang=js&"
import style0 from "./ClientMonetariesTable.vue?vue&type=style&index=0&id=424e2700&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424e2700",
  null
  
)

export default component.exports